<template>
    <router-view></router-view>
</template>

<script>
export default {
  name: "App",
  components: {},

  methods: {},
};
</script>

<style lang='scss'>
@import "assets/home.scss";
@import 'assets/css/color.scss';

</style>
